import animation from './animation';
import base from './base';
import brand from './brand';
import components from './components';
import forms from './forms';
import introduction from './introduction';
import layout from './layout';
import packages from './packages';

export default {
  introduction,
  packages,
  brand,
  animation,
  base,
  components,
  forms,
  layout,
};
